import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

const KEY = ['subscriptions', 'plans'];

/** باقات الاشتراك الشهري (التعريفات). مصفوفة جاهزة — المُعترض يفكّ {items}. */
export function useSubscriptionPlans({ active } = {}) {
  return useQuery({
    queryKey: [...KEY, { active: active ?? null }],
    queryFn: async () => {
      const { data } = await api.get('/subscriptions/plans', {
        params: active === undefined ? undefined : { active }
      });
      return Array.isArray(data) ? data : (data?.items || []);
    },
    staleTime: 30_000
  });
}

function invalidate(qc) {
  qc.invalidateQueries({ queryKey: KEY });
}

export function useCreatePlan() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/subscriptions/plans', body).then((r) => r.data),
    successMessage: 'تمت إضافة باقة الاشتراك',
    onSuccess: () => invalidate(qc)
  });
}

export function useUpdatePlan() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/subscriptions/plans/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ باقة الاشتراك',
    onSuccess: () => invalidate(qc)
  });
}

export function useDeletePlan() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.delete(`/subscriptions/plans/${id}`).then((r) => r.data),
    successMessage: 'تم تعطيل باقة الاشتراك',
    onSuccess: () => invalidate(qc)
  });
}
